import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export default function ViewSummaryCommon({ btnUi, summaryText,btnText }) {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div>
      <span onClick={() => setModalOpen(!modalOpen)}>
        {btnUi || (
          <Button className="trivia-action-button-main" size="sm">
            {btnText || "View Summary"}
          </Button>
        )}
      </span>

      {modalOpen && summaryText ? (
        <Modal isOpen={modalOpen}>
          <ModalHeader
            toggle={() => {
              setModalOpen(!modalOpen);
            }}
            className="trivia_modal_header_bg"
          >
            Summary
          </ModalHeader>
          <ModalBody className="p-3">{summaryText}</ModalBody>
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
}
